///
/// EarthBrowser Admin Dashboard - Root App
///
/// Created: 2025-11-27
/// Copyright (c) 2025 Geodata Labs
///

import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { Toaster } from '@/components/ui/toaster'
import { AdminDashboard } from '@/pages/AdminDashboard'
import { LoginPage } from '@/pages/LoginPage'
import { useAppSelector } from '@/redux/store'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const userProfile = useAppSelector(state => state.user.userProfile)
  const isAdmin = useAppSelector(state => state.user.isAdmin)
  const location = useLocation()

  if (!userProfile) {
    // Preserve deep links (?section=…&user=…) through the auth bounce
    return <Navigate to={{ pathname: '/login', search: location.search }} replace />
  }

  if (!isAdmin) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center p-8">
          <h1 className="text-2xl font-bold text-destructive mb-4">Access Denied</h1>
          <p className="text-muted-foreground">
            You do not have permission to access the admin dashboard.
          </p>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  )
}

